import './App.css';

import { Route, Routes } from 'react-router-dom';

import Home from './components/Home';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';

import Header from './components/Header'; 
import Footer from './components/Footer'; 

import GDG from './components/GDG'; 
import Ski from './components/Ski';

function App() { 
  return (
    <div className='parent'>
      <Header/>
      <Routes>
        <Route path='/' element={<Home/>}/> 
        <Route path='/projects' element={<Projects/>}/> 
        <Route path='/skills' element={<Skills/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/gdg' element={<GDG/>}/> 
        <Route path='/wski' element={<Ski/>}/> 
      </Routes>
      <Footer/>
    </div>
  );
}

export default App; 
